import React from 'react'
import UnitCountThree from './child/UnitCountThree'
import CoinAnalyticsOne from './child/CoinAnalyticsOne'
import CoinAnalyticsTwo from './child/CoinAnalyticsTwo'
import MyOrdersOne from './child/MyOrdersOne'
import RecentTransactionOne from './child/RecentTransactionOne'
import MyCardsOne from './child/MyCardsOne'
import TotalBalanceOne from './child/TotalBalanceOne'
import UserActivatesOne from './child/UserActivatesOne'

const DashBoardLayerFour = () => {
  return (
    <>
      
      <UnitCountThree />
      <section>
        <div className="row gy-4 mt-4">
          <div className="col-xxl-6">
            <div className="card h-100 radius-8 border-0">
              <div className="card-body p-24">
                <h6 className="mb-3">Account Status</h6>
                <p className="text-secondary-light mb-0">
                  Subscription Overview and Usage Summary
                </p>

                <div className='row mt-10'>
                  <div className="col-md-6">
                    <label className="form-label mb-0">Current Plan</label>
                    <p className="mb-0" style={{fontSize:"13px"}}>Basic</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label mb-0">Price</label>
                    <p className="mb-0" style={{fontSize:"13px"}}>INR 999</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label mb-0">Next Renewal</label>
                    <p className="mb-0" style={{fontSize:"13px"}}>July 25,2025</p>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label mb-0">Stocks Usage</label>
                    <p className="mb-0" style={{fontSize:"13px"}}>1 of 5</p>
                  </div>

                  <div className="col-md-12">
                    <button className="btn btn-primary text-sm btn-sm w-100 radius-12 mt-3">
                       Manage Subscription
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          

          <div className="col-xxl-6">
            <div className="card h-100 radius-8 border-0">
              <div className="card-body p-24">
                <h6 className="mb-3">Upgrade to plus</h6>
                <p className="text-secondary-light mb-0">
                  get more feature and track more stock
                </p>
                <label className="form-label mb-0"> ₹ 1,499 / month</label>
                
                <div className='row mt-10'>
                  <div className="col-md-12">
                    <ul>
                      <li>Track up to 5 stocks instead of just 3</li>
                      <li>Real-time alerts, on your schedule.</li>
                      <li>Weekly Market Insights</li>
                      <li>Priority Customer Care</li>
                    </ul>
                  </div>

                  <div className="col-md-12">
                    <button className="btn btn-primary text-sm btn-sm w-100 radius-12 mt-3">
                       Upgrade Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* <section>
        <div className="row gy-4 mt-4">
          <div className="col-xxl-8">
            <div className="row gy-4">

              <CoinAnalyticsOne />


              <CoinAnalyticsTwo />


              <MyOrdersOne />

              <RecentTransactionOne />

            </div>
          </div>

          <div className="col-xxl-4">
            <div className="row gy-4">

              <MyCardsOne />

              <TotalBalanceOne />

              <UserActivatesOne />

            </div>
          </div>
        </div>
      </section> */}
    </>
  )
}

export default DashBoardLayerFour